import * as MODULES from '../module-codes'
import axios from 'axios'
import Mustache from 'mustache'

export const state = () => ({
    certificates: [],
    userCertificates: [],
    dataRetrieved: false,
})

export const getters = {
    processedCertificates: (state, getters, rootState) => {
        return state.userCertificates.map(certificate => {
          let templatedCert = { ...certificate }
          let context = { date: certificate.date, ...rootState }
          templatedCert['body'] = Mustache.render(certificate.body, context)
          return templatedCert
        })
    }
}

export const actions = {
    addUserCertificate: ({ commit, dispatch, rootState }, payload) => {
        commit('ADD_USER_CERTIFICATE', { certificateName: payload.certificateName, rootState })
        dispatch('updateModuleInDB')
    },
    updateModuleInDB: async ({ state, rootState}) => {
        let content = {
            userCertificates: state.userCertificates
        }
        await axios.post('/api/updateModule', {
            params: {
                moduleState: content,
                moduleName: MODULES.CERTIFICATE,
                pcs: localStorage.getItem('pcs'),
                classId: rootState.auth.classId,
            } 
        })
    },
    populateCertificateFromDB: async ({ state, commit }) => {
        return new Promise(function(resolve, reject) {
            commit('SET_CERTIFICATE_DATA_RETRIEVED', true)
            axios.post('/api/pcs/certificate', {
                params: {
                    pcs: localStorage.getItem('pcs')
                }
            }).then(res => {
                commit("SET_CERTIFICATE_MODULE_DATA", res.data['settings'])
                resolve();
            })
        })
    },
    populateFromDB: async ({ state, commit, dispatch }, payload) => {
        if (!state.dataRetrieved) {
            dispatch('populateCertificateFromDB')
        }
        if (payload) {
            commit('SET_CERTIFICATE_USER_CONTENT', payload)
        }
    },
}

export const mutations = {
    SET_CERTIFICATE_MODULE_DATA(state, payload) {
        state.certificates = payload.certificates
    },
    SET_CERTIFICATE_USER_CONTENT(state, payload) {
        state.userCertificates = payload.userCertificates
    },
    SET_CERTIFICATE_DATA_RETRIEVED(state, payload) {
        state.dataRetrieved = payload
    },
    ADD_USER_CERTIFICATE(state, payload) {
        let date = new Date().toLocaleDateString()
        let certificate = state.certificates.find(cert => cert.name === payload.certificateName)
        let rootState = payload.rootState
        let templatedCert = { ...certificate }
        let context = { date: date, ...rootState }
        templatedCert['body'] = Mustache.render(certificate.body, context)
        state.userCertificates.push(templatedCert)
    },
    CLEAR_STATE: state => {
        state.certificates = []
        state.userCertificates = [],
        dataRetrieved = false
      },
}